import React, { Component } from "react"
import { PropTypes } from "prop-types"
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import _ from 'lodash';
import { Row, Col, Button, FormGroup, FormControl, InputGroup } from "react-bootstrap"
import { orange, blue, advancerstatus, AdvancerStatusKey } from '../../../../utils/constants'
import { getActiveSeasons } from '../../../../components/common/api'
import { fetchingAdvancers, fetchAdvancers, triggeringAdvancerProcess, triggerAdvancerProcess } from '../../../../redux/actions/action_postEvent';

const formName = 'postevent'

export const SearchBy = {
  All: 'all',
  Advancer: "advancer",
  Event: 'event',
  Status: 'status'
}

const SearchByDescription = {
  All: "All",
  Advancer: "Advancer's name",
  Event: "Event's name",
  Status: "Status"
}

class SearchBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      seasonId: '',
      searchBy: SearchBy.All,
      searchValue: '',
      seasons: [],
      freeTextSearch: false,
      statusSearchValue: 'active'
    }
    this.handleSearch = this.handleSearch.bind(this)
    this.handleSearchByChange = this.handleSearchByChange.bind(this)
    this.setSearchTextField = this.setSearchTextField.bind(this)
    this.setModes = this.setModes.bind(this)
    this.setSeasons = this.setSeasons.bind(this)
    this.setSelectValues = this.setSelectValues.bind(this)
    this.handleSearchSeasonChange = this.handleSearchSeasonChange.bind(this)
    this.handleSearchByStatusChange = this.handleSearchByStatusChange.bind(this)
    this.handleValueChange = this.handleValueChange.bind(this)
    this.setSearchByOptions = this.setSearchByOptions.bind(this)
    this.handleRunAdvancerProcess = this.handleRunAdvancerProcess.bind(this)
  }

  componentDidMount() {
    const _this = this;
    getActiveSeasons().then(function (response) {
      _this.setState({
        seasons: response.data,
        seasonId: response.data[0].id
      })
    })
  }

  componentWillReceiveProps(nextProps) {
    const { refreshResults } = nextProps;
    if (refreshResults === true) {
      this.handleSearch();
    }
  }

  handleSearchSeasonChange = (event) => {
    const season = event.target.value

    this.setState({
      seasonId: season
    })
  }

  handleSearch() {
    const {
      searchBy,
      searchValue,
      statusSearchValue,
      seasonId
    } = this.state
    let searchVal = searchValue;

    //const searchVal = searchBy === SearchBy.All ? 'all' : searchValue;

    if (searchBy == SearchBy.All) {
      searchVal = 'all';
    }
    else if (searchBy == SearchBy.Status) {
      searchVal = statusSearchValue;
    }


    const { dispatch, onSearch } = this.props;

    dispatch(fetchingAdvancers());
    dispatch(fetchAdvancers(seasonId, searchBy, searchVal));
    onSearch();
  }

  handleSearchByChange = (event) => {

    const searchby = event.target.value;
    let freetextsearch = true;

    if ((searchby == SearchBy.All)) {
      freetextsearch = false;
    }
    this.setModes(freetextsearch, searchby, '');
  }

  handleValueChange(evt) {
    const searchValue = evt.target.value;
    this.setState({ searchValue: searchValue });
  }

  handleSearchByStatusChange(athlete) {
    const searchvalue = athlete.target.value;
    this.setState({ statusSearchValue: searchvalue });
  }

  setSearchTextField = () => {
    const fldtype = 'text'
    return (<FormControl type={fldtype} placeholder='Enter value' style={{ minWidth: '270px' }} value={this.state.searchValue} onChange={this.handleValueChange} />)
  }

  setModes = (freetextsearch = null, searchby = null, searchValue = '') => {
    this.setState({
      freeTextSearch: freetextsearch !== null ? freetextsearch : this.state.freeTextSearch,
      searchBy: searchby !== null ? searchby : this.state.searchBy,
      searchValue,
      statusSearchValue: 'active'
    })
  }

  isFreeText = () => {
    const { searchBy, freeTextSearch } = this.state
    return (searchBy != SearchBy.All && searchBy != SearchBy.Status) && freeTextSearch
  }

  isSelect = () => {
    return this.state.searchBy == SearchBy.Status
  }

  setSelectValues = () => {
    const attrs = {
      name: 'searchvalue',
      componentClass: 'select',
      style: { minWidth: "280px" }
    }
    switch (this.state.searchBy) {
    case SearchBy.Status:
    {
      const active = _.find(advancerstatus, { key: AdvancerStatusKey.Active })
      const optedout = _.find(advancerstatus, { key: AdvancerStatusKey.OptedOut })
      const resolved = _.find(advancerstatus, { key: AdvancerStatusKey.Resolved })
      const orphaned = _.find(advancerstatus, { key: AdvancerStatusKey.Orphaned })

      return (
        <FormControl {...attrs} onChange={this.handleSearchByStatusChange} style={{ minWidth: '250px', borderRadius: '0', height: '36px' }}>
              <option value={active.description}>{active.description}</option>
              <option value={optedout.description}>{optedout.description}</option>
              <option value={resolved.description}>{resolved.description}</option>
              <option value={orphaned.description}>{orphaned.description}</option>
            </FormControl>
      )
    }
    }
  }

  setSeasons() {
    const { seasons } = this.state;
    const seasonsArray = Object.values(seasons)
    const option = seasonsArray.map((season) => {
      return (<option key={season.id} value={season.id}>{season.description}</option>)
    })
    return option
  }

  setSearchByOptions = () => {

    const { SearchByOptions } = this.props

    return ([
      (SearchByOptions ? SearchByOptions.includes(SearchBy.All) : true) && <option value={SearchBy.All} key='1'>{SearchByDescription.All}</option>,
      (SearchByOptions ? SearchByOptions.includes(SearchBy.Advancer) : true) && <option value={SearchBy.Advancer} key='2'>{SearchByDescription.Advancer}</option>,
      (SearchByOptions ? SearchByOptions.includes(SearchBy.Event) : true) && <option value={SearchBy.Event} key='3'>{SearchByDescription.Event}</option>,
      (SearchByOptions ? SearchByOptions.includes(SearchBy.Status) : true) && <option value={SearchBy.Status} key='4'>{SearchByDescription.Status}</option>
    ])
  }

  handleRunAdvancerProcess() {
    const { dispatch } = this.props
    const { seasonId } = this.state

    dispatch(triggeringAdvancerProcess());
    dispatch(triggerAdvancerProcess(seasonId));
  }

  render() {
    const {
      searchValue,
      seasons,
      searchBy
    } = this.state;

    const { searching, runningProcess } = this.props;

    const activeSeasons = (_.find(seasons, { isSeasonSet: true }) !== undefined);

    return (<Row>
      <Col xs={12}>
        <div className="stacked-filter-panel">
          <FormGroup controlId="searchby" className="searchby-filter">
            <FormControl componentClass="select" onChange={this.handleSearchSeasonChange} style={{ minWidth: '120px', borderRadius: '0' }}>
              {
                this.setSeasons()
              }
            </FormControl>
            <FormControl defaultValue={SearchBy.DirectorName} componentClass="select" onChange={this.handleSearchByChange} style={{ minWidth: '180px', borderRadius: '0' }}>
              {
                this.setSearchByOptions()
              }
            </FormControl>
            <InputGroup>
              {
                this.isFreeText() &&
                this.setSearchTextField()
              }
              {
                this.isSelect() &&
                this.setSelectValues()
              }
              <InputGroup.Button>
                <Button onClick={this.handleSearch} style={{ color: orange, marginLeft: '0px', minHeight: '34px' }} disabled={(searchValue.length < 3 && (searchBy == SearchBy.Advancer || searchBy == SearchBy.Event)) || !activeSeasons}>
                  <i className={searching === true ? "fa fa-spinner fa-spin" : "fa fa-search"} aria-hidden="true" />
                </Button>
              </InputGroup.Button>
              <InputGroup.Button>
                <Button style={{ color: blue, minHeight: '36px' }} onClick={this.handleRunAdvancerProcess} disabled={(searchValue.length < 3 && (searchBy == SearchBy.Advancer || searchBy == SearchBy.Event)) || !activeSeasons}>
                  <i className={runningProcess === true ? "fa fa-spinner fa-spin" : "fa fa-cogs"} aria-hidden="true" />&nbsp;&nbsp; Run Advancer Process
							</Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
        </div>
      </Col>
    </Row>)
  }
}

SearchBar.propTypes = {
  dispatch: PropTypes.func,
  SearchByOptions: PropTypes.array,
  searching: PropTypes.bool,
  refreshResults: PropTypes.bool,
  onSearch: PropTypes.func,
  runningProcess: PropTypes.bool
}

function mapStateToProps(state, ownProps) {
  const formName = ownProps.form;
  const selector = formValueSelector(formName);
  const savingTransfer = selector(state, 'savingTransfer');
  const searching = selector(state, 'searching');
  const runningProcess = selector(state, 'runningProcess');
  return {
    savingTransfer,
    searching,
    runningProcess
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchingAdvancers,
    fetchAdvancers,
    triggeringAdvancerProcess,
    triggerAdvancerProcess
  }, dispatch)
}
export default reduxForm({
  form: formName,
  destroyOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(SearchBar))


// WEBPACK FOOTER //
// ./src/containers/postevent/components/manageAdvancers/searchbar.js